/* eslint-disable no-shadow */
export enum HubriseServiceType {
    DELIVERY = 'delivery',
    COLLECTION = 'collection', // = pickup
    EAT_IN = 'eat_in'
}
